module.exports = __webpack_public_path__ + "static/media/profile.15311f91.svg";